'use strict';

Number.isInteger = Number.isInteger || function(value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};

Number.prototype.toRad = function() {
    return this * Math.PI / 180;
};

// https://stackoverflow.com/a/14561433/10149797
Number.haversine = function(lng1, lat1, lng2, lat2) {
    const R = 6371; // km
    const x1 = lat2-lat1;
    const dLat = x1.toRad();
    const x2 = lng2-lng1;
    const dLng = x2.toRad();
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) * Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c; // Distance in km
};
